export default __webpack_public_path__ + "static/media/traffic01.32d27e18.png";